import { render, staticRenderFns } from "./AjoutScore.vue?vue&type=template&id=7d7362b2&scoped=true&"
import script from "./AjoutScore.vue?vue&type=script&lang=js&"
export * from "./AjoutScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7362b2",
  null
  
)

export default component.exports